import {
  getBudgetsData,
  updateBudgetsStatusData,
  getConnectSystemUrlData,
  sendBudgetEmailData,
  addShashokuData,
  editBudgetData,
  confirmBudget,
  getGroupBudgetsData,
  getTicketsGochiData,
  downloadTicketsGroupData,
  postGroupBudgetData,
  putGroupBudgetData,
  toggleUseReceiptData,
  combiniAddShopData,
  combiniEditShopData,
  changeAllowDToFData,
  toggleLalapayEnableData
} from '../libs/apis/BudgetApi';

export const GET_BUDGETS_REQUEST = 'GET_BUDGETS_REQUEST';
export const GET_BUDGETS_SUCCESS = 'GET_BUDGETS_SUCCESS';
export const GET_BUDGETS_FAILURE = 'GET_BUDGETS_FAILURE';

export const GET_TICKETS_GOCHI_REQUEST = 'GET_TICKETS_GOCHI_REQUEST';
export const GET_TICKETS_GOCHI_SUCCESS = 'GET_TICKETS_GOCHI_SUCCESS';
export const GET_TICKETS_GOCHI_FAILURE = 'GET_TICKETS_GOCHI_FAILURE';

export const GET_GROUP_BUDGETS_REQUEST = 'GET_GROUP_BUDGETS_REQUEST';
export const GET_GROUP_BUDGETS_SUCCESS = 'GET_GROUP_BUDGETS_SUCCESS';
export const GET_GROUP_BUDGETS_FAILURE = 'GET_GROUP_BUDGETS_FAILURE';

export const POST_GROUP_BUDGETS_REQUEST = 'POST_GROUP_BUDGETS_REQUEST';
export const POST_GROUP_BUDGETS_SUCCESS = 'POST_GROUP_BUDGETS_SUCCESS';
export const POST_GROUP_BUDGETS_FAILURE = 'POST_GROUP_BUDGETS_FAILURE';

export const PUT_GROUP_BUDGETS_REQUEST = 'PUT_GROUP_BUDGETS_REQUEST';
export const PUT_GROUP_BUDGETS_SUCCESS = 'PUT_GROUP_BUDGETS_SUCCESS';
export const PUT_GROUP_BUDGETS_FAILURE = 'PUT_GROUP_BUDGETS_FAILURE';

export const SEND_BUDGET_EMAIL_REQUEST = 'SEND_BUDGET_EMAIL_REQUEST';
export const SEND_BUDGET_EMAIL_SUCCESS = 'SEND_BUDGET_EMAIL_SUCCESS';
export const SEND_BUDGET_EMAIL_FAILURE = 'SEND_BUDGET_EMAIL_FAILURE';

export const GET_CONNECT_SYSTEM_URL_REQUEST = 'GET_CONNECT_SYSTEM_URL_REQUEST';
export const GET_CONNECT_SYSTEM_URL_SUCCESS = 'GET_CONNECT_SYSTEM_URL_SUCCESS';
export const GET_CONNECT_SYSTEM_URL_FAILURE = 'GET_CONNECT_SYSTEM_URL_FAILURE';

export const UPDATE_BUDGETS_STATUS_REQUEST = 'UPDATE_BUDGETS_STATUS_REQUEST';
export const UPDATE_BUDGETS_STATUS_SUCCESS = 'UPDATE_BUDGETS_STATUS_SUCCESS';
export const UPDATE_BUDGETS_STATUS_FAILURE = 'UPDATE_BUDGETS_STATUS_FAILURE';

export const CONFIRM_BUDGETS_STATUS_REQUEST = 'CONFIRM_BUDGETS_STATUS_REQUEST';
export const CONFIRM_BUDGETS_STATUS_SUCCESS = 'CONFIRM_BUDGETS_STATUS_SUCCESS';
export const CONFIRM_BUDGETS_STATUS_FAILURE = 'CONFIRM_BUDGETS_STATUS_FAILURE';

export const DOWNLOAD_TICKETS_GROUP_REQUEST = 'DOWNLOAD_TICKETS_GROUP_REQUEST';
export const DOWNLOAD_TICKETS_GROUP_SUCCESS = 'DOWNLOAD_TICKETS_GROUP_SUCCESS';
export const DOWNLOAD_TICKETS_GROUP_FAILURE = 'DOWNLOAD_TICKETS_GROUP_FAILURE';

export const EDIT_BUDGET_REQUEST = 'EDIT_BUDGET_REQUEST';
export const EDIT_BUDGET_SUCCESS = 'EDIT_BUDGET_SUCCESS';
export const EDIT_BUDGET_FAILURE = 'EDIT_BUDGET_FAILURE';

export const ADD_SHASHOKU_REQUEST = 'ADD_SHASHOKU_REQUEST';
export const ADD_SHASHOKU_SUCCESS = 'ADD_SHASHOKU_SUCCESS';
export const ADD_SHASHOKU_FAILURE = 'ADD_SHASHOKU_FAILURE';

export const TOGGLE_USE_RECEIPT_REQUEST = 'TOGGLE_USE_RECEIPT_REQUEST';
export const TOGGLE_USE_RECEIPT_SUCCESS = 'TOGGLE_USE_RECEIPT_SUCCESS';
export const TOGGLE_USE_RECEIPT_FAILURE = 'TOGGLE_USE_RECEIPT_FAILURE';

export const COMBINI_ADD_SHOP_REQUEST = 'COMBINI_ADD_SHOP_REQUEST';
export const COMBINI_ADD_SHOP_SUCCESS = 'COMBINI_ADD_SHOP_SUCCESS';
export const COMBINI_ADD_SHOP_FAILURE = 'COMBINI_ADD_SHOP_FAILURE';

export const COMBINI_EDIT_SHOP_REQUEST = 'COMBINI_EDIT_SHOP_REQUEST';
export const COMBINI_EDIT_SHOP_SUCCESS = 'COMBINI_EDIT_SHOP_SUCCESS';
export const COMBINI_EDIT_SHOP_FAILURE = 'COMBINI_EDIT_SHOP_FAILURE';

export const CHANGE_ALLOW_D_TO_F_REQUEST = 'CHANGE_ALLOW_D_TO_F_REQUEST';
export const CHANGE_ALLOW_D_TO_F_SUCCESS = 'CHANGE_ALLOW_D_TO_F_SUCCESS';
export const CHANGE_ALLOW_D_TO_F_FAILURE = 'CHANGE_ALLOW_D_TO_F_FAILURE';

export const TOGGLE_LALAPAY_ENABLE_REQUEST = 'TOGGLE_LALAPAY_ENABLE_REQUEST';
export const TOGGLE_LALAPAY_ENABLE_SUCCESS = 'TOGGLE_LALAPAY_ENABLE_SUCCESS';
export const TOGGLE_LALAPAY_ENABLE_FAILURE = 'TOGGLE_LALAPAY_ENABLE_FAILURE';

export const sendBudgetEmail = params => dispatch => {
  dispatch({ type: SEND_BUDGET_EMAIL_REQUEST });
  return sendBudgetEmailData(params)
    .then(response =>
      dispatch({
        type: SEND_BUDGET_EMAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SEND_BUDGET_EMAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGroupBudgets = params => dispatch => {
  dispatch({ type: GET_GROUP_BUDGETS_REQUEST });
  return getGroupBudgetsData(params)
    .then(response =>
      dispatch({
        type: GET_GROUP_BUDGETS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUP_BUDGETS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getTicketsGochi = params => dispatch => {
  dispatch({ type: GET_TICKETS_GOCHI_REQUEST });
  return getTicketsGochiData(params)
    .then(response =>
      dispatch({
        type: GET_TICKETS_GOCHI_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_TICKETS_GOCHI_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const postGroupBudgets = params => dispatch => {
  dispatch({ type: POST_GROUP_BUDGETS_REQUEST });
  return postGroupBudgetData(params)
    .then(response =>
      dispatch({
        type: POST_GROUP_BUDGETS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: POST_GROUP_BUDGETS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const putGroupBudgets = params => dispatch => {
  dispatch({ type: PUT_GROUP_BUDGETS_REQUEST });
  return putGroupBudgetData(params)
    .then(response =>
      dispatch({
        type: PUT_GROUP_BUDGETS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: PUT_GROUP_BUDGETS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getBudgets = params => dispatch => {
  dispatch({ type: GET_BUDGETS_REQUEST });
  return getBudgetsData(params)
    .then(response =>
      dispatch({
        type: GET_BUDGETS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_BUDGETS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const confirmBudgetStatus = params => dispatch => {
  dispatch({ type: CONFIRM_BUDGETS_STATUS_REQUEST });
  return confirmBudget(params)
    .then(response =>
      dispatch({
        type: CONFIRM_BUDGETS_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: CONFIRM_BUDGETS_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateBudgetsStatus = params => dispatch => {
  dispatch({ type: UPDATE_BUDGETS_STATUS_REQUEST });
  return updateBudgetsStatusData(params)
    .then(response =>
      dispatch({
        type: UPDATE_BUDGETS_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_BUDGETS_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editBudget = (budgetId, amount) => dispatch => {
  dispatch({ type: EDIT_BUDGET_REQUEST });
  return editBudgetData(budgetId, amount)
    .then(response =>
      dispatch({
        type: EDIT_BUDGET_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_BUDGET_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getConnectSystemUrl = params => dispatch => {
  dispatch({ type: GET_CONNECT_SYSTEM_URL_REQUEST });
  return getConnectSystemUrlData(params)
    .then(response =>
      dispatch({
        type: GET_CONNECT_SYSTEM_URL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_CONNECT_SYSTEM_URL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addShashoku = params => dispatch => {
  dispatch({ type: ADD_SHASHOKU_REQUEST });
  return addShashokuData(params)
    .then(response =>
      dispatch({
        type: ADD_SHASHOKU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_SHASHOKU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadTicketsGroup = params => dispatch => {
  dispatch({ type: DOWNLOAD_TICKETS_GROUP_REQUEST });
  return downloadTicketsGroupData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_TICKETS_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_TICKETS_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const toggleUseReceipt = (params, connectSystemId) => async dispatch => {
  dispatch({ type: TOGGLE_USE_RECEIPT_REQUEST });
  try {
    const response = await toggleUseReceiptData(params, connectSystemId);
    return dispatch({
      type: TOGGLE_USE_RECEIPT_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    return dispatch({
      type: TOGGLE_USE_RECEIPT_FAILURE,
      payload: error.response,
      error: true
    });
  }
};

export const combiniAddShop = params => async dispatch => {
  dispatch({ type: COMBINI_ADD_SHOP_REQUEST });
  try {
    const response = await combiniAddShopData(params);
    return dispatch({
      type: COMBINI_ADD_SHOP_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    return dispatch({
      type: COMBINI_ADD_SHOP_FAILURE,
      payload: error.response,
      error: true
    });
  }
};

export const combiniEditShop = params => async dispatch => {
  dispatch({ type: COMBINI_EDIT_SHOP_REQUEST });
  try {
    const response = await combiniEditShopData(params);
    return dispatch({
      type: COMBINI_EDIT_SHOP_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    return dispatch({
      type: COMBINI_EDIT_SHOP_FAILURE,
      payload: error.response,
      error: true
    });
  }
};

export const changeAllowDToF = (systemId, params) => async dispatch => {
  dispatch({ type: CHANGE_ALLOW_D_TO_F_REQUEST });
  try {
    const response = await changeAllowDToFData(systemId, params);
    return dispatch({
      type: CHANGE_ALLOW_D_TO_F_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    return dispatch({
      type: CHANGE_ALLOW_D_TO_F_FAILURE,
      payload: error.response,
      error: true
    });
  }
};

export const toggleLalapayEnable = (
  params,
  connectSystemId
) => async dispatch => {
  dispatch({ type: TOGGLE_LALAPAY_ENABLE_REQUEST });
  try {
    const response = await toggleLalapayEnableData(params, connectSystemId);
    return dispatch({
      type: TOGGLE_LALAPAY_ENABLE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    return dispatch({
      type: TOGGLE_LALAPAY_ENABLE_FAILURE,
      payload: error.response,
      error: true
    });
  }
};
